import request from '../servises/blogRequest'

export function getTags(params) {
    return request({
        url: `tags`,
        method: 'GET',
        params: params
    })
}
export function deleteTag(params) {
    return request({
        url: `tags/${params}`,
        method: 'DELETE'
    })
}

export function getShowTag(params) {
    return request({
        url: `tags/${params}`,
        method: 'GET'
    })
}

export function updateTag(params) {
    return request({
        url: `tags/${params.id}`,
        method: 'PUT',
        data: params
    })
}

export function createTag(params) {
    return request({
        url: `tags`,
        method: 'POST',
        data: params
    })
}
